<template>
  <div class="my-text">
    <span 
      class="text-content" 
      :title="isOverflow ? format() : ''"
      ref="textContentRef"
    >
      {{ format() }}
    </span>
  </div>
</template>

<script setup>
import {defineProps, useAttrs, ref, computed} from 'vue';
import { dateFormat } from '@/utils';

const props = defineProps({
  modelValue: {
    type: [String, Number], 
  },
  mode: {
    type: [String], 
  },
  format: {
    type: [Function],
  },
  fieldLabel: {
    type: String,
  }
});

const attrs = useAttrs();
const textContentRef = ref(null);
// 获取内容是否超出
const isOverflow = computed(() => textContentRef.value?.scrollWidth > textContentRef.value?.parentElement.clientWidth - 1);

// 格式化显示内容
const format = () => {
  if (props.format && typeof props.format === 'function') {
    return props.format(props.modelValue, attrs.onGetFormData ? attrs.onGetFormData() : {});
  }
  if (attrs.options) {
    return attrs.options.filter(item => item.value == props.modelValue)?.map(item => item.label).join(',');
  }
  if (attrs.onGetFormData && attrs.fieldNames) {
    return attrs.onGetFormData()[props.fieldLabel || attrs.fieldNames.label];
  }
  if (!props.mode) {
    return props.modelValue;
  }
  if (props.mode == 'time') {
    return dateFormat(props.modelValue, 'YYYY/MM/DD HH:mm:ss');
  }
  if (props.mode == 'date') {
    return dateFormat(props.modelValue, 'YYYY/MM/DD');
  }
  return props.modelValue;
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.my-text {
  display: inline-block;
  width: 100%;
  margin: 5px 0;
  word-wrap: break-word;
  position: relative;
}

.text-content {
  display: inline-block;
  vertical-align: top;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>